import { createService } from "../../services/serviceFactory";

const createData = (
  route,
  createDataItem,
  setAllData,
  setOpenDialog,
  allData,
  setIsLoading,
) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    console.log("No token available");
    setOpenDialog(false);
    setIsLoading(false);
    return;
  }

  const serviceType = route.split('/').pop(); // Infer from route, e.g., /api/currencies -> 'currencies'
  const service = createService(serviceType);

  setIsLoading(true);

  service.create(createDataItem, token)
    .then((newItem) => {
      setAllData([newItem, ...allData]);
      // TODO: Success notification
      setOpenDialog(false);
      setIsLoading(false);
    })
    .catch((error) => {
      console.log("Create failed:", error);
      setOpenDialog(false);
      setIsLoading(false);
    });
};

export default createData;